module.exports = __webpack_public_path__ + "static/media/heart-outline.7ff622ad.svg";